import React, { useEffect, useState } from 'react';

//import Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import useLayoutStore from '../Store/layouts/layouts';
import withRouter from '../Components/Common/withRouter';


const Layout = (props: any) => {
  const [headerClass, setHeaderClass] = useState("");

  const hamburgerIcon = document.querySelector('.hamburger-icon');

  const { layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    sidebarVisibilitytype,
    changeLeftsidebarViewType,
    changeLeftsidebarSizeType,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLayout,
    changeSidebarImageType,
    changeSidebarVisibility,
  } = useLayoutStore((state: any) => ({
    layoutType: state.layoutType,
    leftSidebarType: state.leftSidebarType,
    layoutModeType: state.layoutModeType,
    layoutWidthType: state.layoutWidthType,
    layoutPositionType: state.layoutPositionType,
    topbarThemeType: state.topbarThemeType,
    leftsidbarSizeType: state.leftsidbarSizeType,
    leftSidebarViewType: state.leftSidebarViewType,
    leftSidebarImageType: state.leftSidebarImageType,
    sidebarVisibilitytype: state.sidebarVisibilitytype,
    changeLeftsidebarViewType: state.changeLeftsidebarViewType,
    changeLeftsidebarSizeType: state.changeLeftsidebarSizeType,
    changeSidebarTheme: state.changeSidebarTheme,
    changeLayoutMode: state.changeLayoutMode,
    changeLayoutWidth: state.changeLayoutWidth,
    changeLayoutPosition: state.changeLayoutPosition,
    changeTopbarTheme: state.changeTopBarTheme,
    changeLayout: state.changeLayout,
    changeSidebarImageType: state.changeSidebarImageType,
    changeSidebarVisibility: state.changeSidebarVisibility,
  }))

  /*
   layout settings
   */
  useEffect(() => {
    if (
      layoutType ||
      leftSidebarType ||
      layoutModeType ||
      layoutWidthType ||
      layoutPositionType ||
      topbarThemeType ||
      leftsidbarSizeType ||
      leftSidebarViewType ||
      leftSidebarImageType ||
      sidebarVisibilitytype
    ) {
      window.dispatchEvent(new Event('resize'));
      changeLeftsidebarViewType(leftSidebarViewType);
      changeLeftsidebarSizeType(leftsidbarSizeType);
      changeSidebarTheme(leftSidebarType);
      changeLayoutMode(layoutModeType);
      changeLayoutWidth(layoutWidthType);
      changeLayoutPosition(layoutPositionType);
      changeTopbarTheme(topbarThemeType);
      changeLayout(layoutType);
      changeSidebarImageType(leftSidebarImageType);
      changeSidebarVisibility(sidebarVisibilitytype);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutType,
    leftSidebarType,
    layoutModeType,
    layoutWidthType,
    layoutPositionType,
    topbarThemeType,
    leftsidbarSizeType,
    leftSidebarViewType,
    leftSidebarImageType,
    sidebarVisibilitytype,
  ]);

  // class add remove in header 
  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
  });

  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass("topbar-shadow");
    } else {
      setHeaderClass("");
    }
  }

  useEffect(() => {
    if (sidebarVisibilitytype === 'show' || layoutType === "vertical" || layoutType === "twocolumn") {
      if (hamburgerIcon != null) {
        hamburgerIcon.classList.remove('open');
      }
    } else {
      if (hamburgerIcon != null)
        hamburgerIcon.classList.add('open');
    }
  }, [sidebarVisibilitytype, layoutType, hamburgerIcon]);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header
          headerClass={headerClass}
        />
        <Sidebar
          layoutType={layoutType}
        />
        <div className="main-content">
          {props.children}
          <Footer />
        </div>
      </div>
    </React.Fragment>

  );
};


export default withRouter(Layout);